import styled from "styled-components";

import { bp, flexColumn, media, pseudo } from "@styles/Utilities.styled";


export const StyledVirtualSlots = styled.div`
  margin-top: 2rem;
  position: relative;
  width: 100%;
  ${flexColumn}
  align-items: start;
  gap: 3rem;
  padding-bottom: 3rem;
  margin-bottom: 5rem;

  ${media(bp.large2)} {
    flex-direction: row;
    justify-content: space-between;
    gap: 1rem;
    /* padding-bottom: 0; */

    &::before {
      ${pseudo}
      height: 100svh;
      height: 100vh;
      width: 1px;
      top: 0;
      left: 50%;
      background-color: var(--clr-gray-150);
    }

    & > div {
      flex-basis: 50%;
    }
  }
`;
